import React from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';

import 'antd/dist/reset.css';
import './style/global.scss';

import App from './App';
import * as serviceWorker from './serviceWorker';
import { ensureMatchMedia } from './polyfills/matchMedia';
import { ensureMessageChannel } from './polyfills/messageChannel';
import { startDragDiagnostics } from './services/dragDiagnostics';
import { redirectLegacyLogin, startLogoutSync } from './services/logoutSync';

import { getStore } from './state/store';

ensureMatchMedia();
ensureMessageChannel();
startDragDiagnostics();
startLogoutSync();

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container not found');
}

const renderBootstrapError = (error: unknown) => {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  const message =
    error instanceof Error ? error.stack || error.message : String(error);

  container.innerHTML = `
    <div style="min-height:100vh;padding:32px;background:#1f1f1f;color:#fff;font-family:monospace;white-space:pre-wrap;">
      <h1 style="font-family:sans-serif;margin-top:0;">Bootstrap error</h1>
      ${message}
    </div>
  `;
};

window.addEventListener('error', event => {
  renderBootstrapError(event.error || event.message);
});

window.addEventListener('unhandledrejection', event => {
  renderBootstrapError(event.reason);
});

try {
  if (!redirectLegacyLogin()) {
    createRoot(container).render(
      <Provider store={getStore()}>
        <App />
      </Provider>,
    );
  }
} catch (error) {
  renderBootstrapError(error);
  throw error;
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
